const NAME = 'single';

export default {
  FETCH: `${NAME}/FETCH`,
  FETCHING: `${NAME}/FETCHING`,
  FETCHED: `${NAME}/FETCHED`,
  FAILED: `${NAME}/FAILED`,
  MERGE: `${NAME}/MERGE`,
};
